import { Icon, Table } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../locales/translations';
import { AcademicOfferRequirement } from '../types';

type AcademicOfferRequirementsBaseProps = {
  admissionRequirements?: Array<{ id: string; name: string }>;
  requirements?: AcademicOfferRequirement[];
  onPressRemoveRequirement?: (index: number) => void;
};

export function AcademicOfferRequirementsBase({
  admissionRequirements = [],
  requirements = [],
  onPressRemoveRequirement,
}: AcademicOfferRequirementsBaseProps) {
  const { t } = useTranslation(
    TranslationsKeys.CONTINUOUS_EDUCATION_ACADEMIC_OFFERS,
  );
  return (
    <div>
      <Table
        columns={[
          {
            columnName: 'name',
            thClassName: 'text-center',
            tdClassName: 'text-center',
            headerText: t(`requirements.base.table.name`),
            cellFormat({ row }) {
              const requirement = admissionRequirements.find(
                (ar) => ar.id === row.ceAdmissionRequirementId,
              );
              return requirement?.name || '';
            },
          },
          {
            columnName: 'description',
            thClassName: 'text-center',
            tdClassName: 'text-center',
            headerText: t(`requirements.base.table.description`),
          },
          {
            columnName: 'action',
            thClassName: 'text-center',
            tdClassName: 'text-center',
            headerText: t(`requirements.base.table.action`),
            cellFormat({ index }) {
              return (
                <>
                  <button
                    type="button"
                    className="btn"
                    onClick={() => {
                      !!onPressRemoveRequirement &&
                        onPressRemoveRequirement(index);
                    }}
                  >
                    <Icon name="trash" />
                  </button>
                </>
              );
            },
          },
        ]}
        data={requirements}
      />
    </div>
  );
}
